import { useAtom } from "jotai";
import { applicationConfigAtom, profileDataAtom } from "./state/store";
import buildRouter from "./routes/routeBuilder";
import { registerApiClient } from "./api/apiClient";
import { App as AntApp, ConfigProvider } from "antd";
import { RouterProvider } from "react-router-dom";
import enUS from "antd/lib/locale/en_US";
import hrHR from "antd/lib/locale/hr_HR";
import { useMemo } from "react";

export default function App() {
	const [applicationConfig] = useAtom(applicationConfigAtom);
	const [profileData] = useAtom(profileDataAtom);

	const router = useMemo(() => {
		return buildRouter();
	}, [applicationConfig]);

	registerApiClient();

	return (
		<ConfigProvider locale={profileData?.selectedLanguage === "hr" ? hrHR : enUS}>
			<AntApp>{router && <RouterProvider router={router} />}</AntApp>
		</ConfigProvider>
	);
}
